<div *ngFor="let section of sections">
  <div class="api-reference-bold-text" [innerHTML]="section.body | mdToHtml"></div>
  <div class="api-reference-bold-text" [innerHTML]="section.subBody || '' | mdToHtml"></div>
</div>
